import React from "react";
import BlogSection from "../components/BlogSection";
export default function Blog() {
	return (
		<>
			<BlogSection></BlogSection>
		</>
	);
}
